// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-grid-table,
.css-grid-table-header,
.css-grid-table-body {
  display: grid;
}

.css-grid-table {
  grid-template-rows: 24px 72px;
  width: 100%;
}

.css-grid-table-header,
.css-grid-table-body {
  grid-template-columns: auto auto auto minmax(150px, 25%);
  line-height: 24px;
}

.css-grid-table-header {
  grid-column-gap: 2px;
  grid-template-rows: auto;
}

.css-grid-table-body {
  grid-template-rows: auto auto auto;
}

.css-grid-table-header div {
  text-align: center;
  font-weight: 200;
  background-color: yellow;
  font-size: 11px;
}

.div-panel {
  overflow-y: scroll;
  float: left;
  width: 100%;
  height: auto;
  height: calc(100vh - 40px);
}

table tr td {
  padding: 5px 6px;
  font-size: 12px;
}
table tr.thead {
  border-bottom: 2px solid #a0b2c6;
}
table tr.thead th {
  padding: 5px 6px;
}

table thead {
  border-bottom: 1px solid #a0b2c6;
  font-size: 13px;
  vertical-align: middle;
  color: #484b4e;
}

table tbody tr {
  border-bottom: 1px solid #e0e6eb !important;
}

.size-font {
  font-size: 10px;
}

.grid-3 thead th:nth-child(-n+3),
.grid-3 tbody tr td:nth-child(-n+3) {
  width: 40%;
  font-size: 12px;
}

.grid-3 thead th:first-child,
.grid-3 tbody tr td:first-child {
  width: 20%;
}

.grid-7 thead th:nth-child(-n+7),
.grid-7 tbody tr td:nth-child(-n+7) {
  width: 16%;
}

.grid-7 thead th:first-child,
.grid-7 tbody tr td:first-child,
.grid-7 thead th:last-child,
.grid-7 tbody tr td:last-child {
  width: 10%;
}`, "",{"version":3,"sources":["webpack://./src/app/common/ieg-auditlog-main/audit-logs/audit-logs-export/audit-logs-export.component.scss"],"names":[],"mappings":"AAAA;;;EAGI,aAAA;AACJ;;AAEA;EACI,6BAAA;EACA,WAAA;AACJ;;AAEA;;EAEI,wDAAA;EACA,iBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AACJ;;AAGI;EACI,gBAAA;EACA,eAAA;AAAR;AAEI;EACI,gCAAA;AAAR;AACQ;EACI,gBAAA;AACZ;;AAIA;EACI,gCAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AADJ;;AAIA;EACI,2CAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;;EAEI,UAAA;EACA,eAAA;AADJ;;AAIA;;EAEI,UAAA;AADJ;;AAIA;;EAEI,UAAA;AADJ;;AAIA;;;;EAII,UAAA;AADJ","sourcesContent":[".css-grid-table,\r\n.css-grid-table-header,\r\n.css-grid-table-body {\r\n    display: grid;\r\n}\r\n\r\n.css-grid-table {\r\n    grid-template-rows: 24px 72px;\r\n    width: 100%;\r\n}\r\n\r\n.css-grid-table-header,\r\n.css-grid-table-body {\r\n    grid-template-columns: auto auto auto minmax(150px, 25%);\r\n    line-height: 24px;\r\n}\r\n\r\n.css-grid-table-header {\r\n    grid-column-gap: 2px;\r\n    grid-template-rows: auto;\r\n}\r\n\r\n.css-grid-table-body {\r\n    grid-template-rows: auto auto auto;\r\n}\r\n\r\n.css-grid-table-header div {\r\n    text-align: center;\r\n    font-weight: 200;\r\n    background-color: yellow;\r\n    font-size: 11px;\r\n}\r\n\r\n.div-panel {\r\n    overflow-y: scroll;\r\n    float: left;\r\n    width: 100%;\r\n    height: auto;\r\n    height: calc(100vh - 40px);\r\n}\r\n\r\ntable {\r\n    tr td {\r\n        padding: 5px 6px;\r\n        font-size: 12px;\r\n    }\r\n    tr.thead {\r\n        border-bottom: 2px solid #a0b2c6;\r\n        th {\r\n            padding: 5px 6px;\r\n        }\r\n    }\r\n}\r\n\r\ntable thead {\r\n    border-bottom: 1px solid #a0b2c6;\r\n    font-size: 13px;\r\n    vertical-align: middle;\r\n    color: #484b4e;\r\n}\r\n\r\ntable tbody tr {\r\n    border-bottom: 1px solid #e0e6eb !important;\r\n}\r\n\r\n.size-font {\r\n    font-size: 10px;\r\n}\r\n\r\n.grid-3 thead th:nth-child(-n+3),\r\n.grid-3 tbody tr td:nth-child(-n+3) {\r\n    width: 40%;\r\n    font-size: 12px;\r\n}\r\n\r\n.grid-3 thead th:first-child,\r\n.grid-3 tbody tr td:first-child {\r\n    width: 20%;\r\n}\r\n\r\n.grid-7 thead th:nth-child(-n+7),\r\n.grid-7 tbody tr td:nth-child(-n+7) {\r\n    width: 16%;\r\n}\r\n\r\n.grid-7 thead th:first-child,\r\n.grid-7 tbody tr td:first-child,\r\n.grid-7 thead th:last-child,\r\n.grid-7 tbody tr td:last-child {\r\n    width: 10%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
